var map = {
	"./angleLeft": [
		2020
	],
	"./angleLeft.tsx": [
		2020
	],
	"./arrow-right": [
		56549,
		6549
	],
	"./arrow-right.tsx": [
		56549,
		6549
	],
	"./bullet": [
		68811
	],
	"./bullet.tsx": [
		68811
	],
	"./check": [
		68,
		68
	],
	"./check.tsx": [
		68,
		68
	],
	"./checked": [
		91496,
		1496
	],
	"./checked.tsx": [
		91496,
		1496
	],
	"./circlePlus": [
		11185,
		1185
	],
	"./circlePlus.tsx": [
		11185,
		1185
	],
	"./clock": [
		83008
	],
	"./clock.tsx": [
		83008
	],
	"./close": [
		86606
	],
	"./close.tsx": [
		86606
	],
	"./error": [
		28568,
		8568
	],
	"./error.tsx": [
		28568,
		8568
	],
	"./external": [
		77358,
		7358
	],
	"./external.tsx": [
		77358,
		7358
	],
	"./facebook": [
		61715,
		1715
	],
	"./facebook.tsx": [
		61715,
		1715
	],
	"./ghost-email": [
		54568,
		4568
	],
	"./ghost-email.tsx": [
		54568,
		4568
	],
	"./ghost-facebook": [
		56815,
		6815
	],
	"./ghost-facebook.tsx": [
		56815,
		6815
	],
	"./ghost-link": [
		78068,
		8068
	],
	"./ghost-link.tsx": [
		78068,
		8068
	],
	"./ghost-linkedin": [
		27007,
		7007
	],
	"./ghost-linkedin.tsx": [
		27007,
		7007
	],
	"./ghost-star": [
		99283,
		9283
	],
	"./ghost-star.tsx": [
		99283,
		9283
	],
	"./ghost-twitter": [
		49424,
		9424
	],
	"./ghost-twitter.tsx": [
		49424,
		9424
	],
	"./ghost-whatsapp": [
		30431,
		431
	],
	"./ghost-whatsapp.tsx": [
		30431,
		431
	],
	"./global": [
		11050
	],
	"./global.tsx": [
		11050
	],
	"./instagram": [
		79044,
		9044
	],
	"./instagram.tsx": [
		79044,
		9044
	],
	"./linkedin": [
		5003,
		5003
	],
	"./linkedin.tsx": [
		5003,
		5003
	],
	"./magnifier": [
		267
	],
	"./magnifier.tsx": [
		267
	],
	"./serasa": [
		44627
	],
	"./serasa.tsx": [
		44627
	],
	"./spotify": [
		32855,
		2855
	],
	"./spotify.tsx": [
		32855,
		2855
	],
	"./star": [
		43614,
		3614
	],
	"./star.tsx": [
		43614,
		3614
	],
	"./user": [
		12768,
		2768
	],
	"./user.tsx": [
		12768,
		2768
	],
	"./videoPlayer": [
		42630
	],
	"./videoPlayer.tsx": [
		42630
	],
	"./whatsapp": [
		18079
	],
	"./whatsapp.tsx": [
		18079
	],
	"./youtube": [
		98612,
		8612
	],
	"./youtube.tsx": [
		98612,
		8612
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 79932;
module.exports = webpackAsyncContext;